<template>
  <div>
    <div class="sidenav-container">
      <!-- Sidenav for settings -->
      <div class="sidenav">
        <SettingsLayout active="PaymentSettings"></SettingsLayout>
      </div>
      <!-- General settings content -->
      <div
        class="sidenave-main-content"
        style="padding:0 !important;margin-top:-6px;overflow-y:hidden"
      >
        <b-row class="px-3 border-bottom">
          <b-col cols="12" class="px-0">
            <h2
              class="custom-page-title mb-2 mt-1 px-4"
              style="position:relative;bottom:4px;"
            >Payment Received</h2>
          </b-col>
        </b-row>
        <div
          class="sidenav-view-block pb-4"
          style="padding-left:0 !important;padding-right:0 !important;height: calc(100vh - 92px)"
        >
          <!-- Validation for sales -->
          <b-tabs class="customer_view_tab no-flex-grow mb-5 mt-1 border-tab">
            <b-tab title="General" active class="p-3">
              <b-form @submit.prevent="onSubmit">
                <div class="page">
                  <b-row>
                    <b-col>
                      <b-form-checkbox
                        plain
                        class="mb-4"
                        v-model.trim="field.pymt_code_field"
                      >Show customize payment received code option</b-form-checkbox>
                      <br />
                    </b-col>
                  </b-row>

                  <!-- <hr align="left" width="60%" /> -->
                  <b-form-group class="mb-1">
                    <b-row style="max-width:900px; font-family:sans-serif">
                      <!--  Description -->
                      <b-col xl="7" lg="7" cols="12">
                        <b-form-group
                          label="Customer Notes"
                          label-for="description"
                          breakpoint="md"
                        >
                          <b-form-textarea
                            name="cus_notes"
                            v-validate="'max:2000'"
                            :rows="6"
                            id="cus_inv_notes"
                            v-model="field.cus_inv_notes"
                          />
                          <span
                            class="text-danger"
                            v-if="errors.has('cus_notes')"
                          >Customer Notes should not exceed 2000 characters</span>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form-group>

                  <!-- footer block -->
                </div>
                <div class="footer sidenav-footer" style="box-shadow:0 -4px 5px -3px #ccc;">
                  <div class="form-action" style="background:none !important;">
                    <b-button
                      type="submit"
                      size="sm"
                      variant="primary"
                      class="btn-rounded mr-3"
                      :disabled="submitted"
                      @click="general_settings=true"
                    >
                      <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Save
                    </b-button>
                  </div>
                </div>
              </b-form>
            </b-tab>
            <b-tab title="Field Customization" class="p-0 pt-2" @click="fetchCustomList()">
              <CustomFieldSettings
                v-on:handledelete="handledelete"
                v-on:onSubmit="customsubmit"
                custom_prefix="pymnt_receive_"
                :custom_field="custom_field"
                :max_count="max_count"
                :used_count="used_count"
                v-on:ConfigureSubmit="configureSubmit"
                :stg_menu="stg_menu"
              />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
 
 <script>
import CustomFieldSettings from "@/components/Form/Settings/CustomField";
import SettingsLayout from "@/components/Layout/SettingsLayout";
import { mapState } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
export default {
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: { SettingsLayout, CustomFieldSettings },
  data() {
    return {
      index_value: "",
      error_show: false, // to show the error message
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,

      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
      submitted: false,
      update_id: "",
      general_settings: false,
      stg_menu: "Payments Received",
      remaining_fields: ""
    };
  },

  methods: {
    fetchCustomList() {
      this.$store.dispatch("settings/fetchCustomList", {
        stg_menu: "Payments Received"
      });
    },
    configureSubmit(ev) {
      var data = JSON.stringify({
        id: ev.id,
        stg_menu: "Payments Received",
        app_id: process.env.VUE_APP_APP_ID,
        permissions: ev.permissions
      });
      this.$store
        .dispatch("settings/configureAccessUpdate", data)
        .then(response => {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.code == 200 ? "success" : "danger",
            showCloseButton: true
          });
          if (response.status == 200) {
            this.fetchCustomList();
            this.$store.state.permission.pymnt_settings_details.custom_field =
              response.data.custom_field;
          }
        });
    },
    removeRow(index) {
      if (this.custom_field.length > 1) {
        this.custom_field.splice(index, 1);
      }
    },
    handledelete(ev) {
      var data = JSON.stringify({
        id: ev.index_value,
        stg_menu: "Payments Received",
        table_name: "cbs_inv_tbl_tns_usr_pymnt_hdr"
      });
      this.$store.dispatch("settings/postdelete", data).then(() => {
        this.fetchCustomList();
        this.$router.push({
          name: this.$route.name,
          query: {
            update:
              this.$route.query.update || this.$route.query.update == true
                ? false
                : true
          }
        });
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: this.message,
          type: this.code == 200 ? "success" : "danger",

          showCloseButton: true
        });
      });
    },
    async customsubmit(ev) {
      if (ev.custom_field == 1) {
        //this.field.custom = true;

        //this.field.index = ev.index;
        this.field.field = ev.custom_data;
        this.update_id = ev.update_id;
        this.remaining_fields = ev.remaining_fields;
        this.general_settings = false;
        //this.field.page = ev.page;
        await this.settingsdata();
      }
    },
    settingsdata() {
      if (this.general_settings) {
        var data = {
          field: this.field,
          stg_menu: "Payments Received",
          table_name: "cbs_inv_tbl_tns_usr_pymnt_hdr"
        };
        this.$store.dispatch("settings/invoice", data).then(result => {
          if (result.status == 201) {
            //  code for notificatin display
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: result.data.status,
              type: "danger",
              showCloseButton: true
            });
            return;
          }
          this.page = "";
          this.$router.push({
            name: this.$route.name,
            query: {
              update:
                this.$route.query.update || this.$route.query.update == true
                  ? false
                  : true
            }
          });
          //  code for notificatin display
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: result.data.status,
            type: "success",
            showCloseButton: true
          });
        });
      } else {
        var data = {
          field: this.field.field,
          remaining_fields: this.remaining_fields,
          stg_menu: "Payments Received",
          table_name: "cbs_inv_tbl_tns_usr_pymnt_hdr"
          // custom_field: this.custom_field
        };

        if (this.page == "create") {
          this.$store
            .dispatch("settings/customfieldcreate", data)
            .then(result => {
              if (result.status == 201) {
                //  code for notificatin display
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: result.data.status,
                  type: "danger",
                  showCloseButton: true
                });
                return;
              }
              if (result.status == 200) {
                this.$store.state.permission.pymnt_settings_details.custom_field =
                  result.data.custom_field;
                this.fetchCustomList();
              }
              this.page = "";
              this.$router.push({
                name: this.$route.name,
                query: {
                  update:
                    this.$route.query.update || this.$route.query.update == true
                      ? false
                      : true
                }
              });
              //  code for notificatin display
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: this.status_message,
                type: "success",
                showCloseButton: true
              });
            });
        }
        if (this.page == "update") {
          this.$store
            .dispatch("settings/customfieldupdate", {
              data: data,
              remaining_fields: this.remaining_fields,
              id: this.update_id
            })
            .then(result => {
              if (result.status == 201) {
                //  code for notificatin display
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: result.data.status,
                  type: "danger",
                  showCloseButton: true
                });
                return;
              }
              if (result.status == 200) {
                this.$store.state.permission.pymnt_settings_details.custom_field =
                  result.data.custom_field;
                this.fetchCustomList();
              }
              this.page = "";
              this.$router.push({
                name: this.$route.name,
                query: {
                  update:
                    this.$route.query.update || this.$route.query.update == true
                      ? false
                      : true
                }
              });
              //  code for notificatin display
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: this.status_message,
                type: "success",
                showCloseButton: true
              });
            });
        }
      }
    },
    async onSubmit() {
      // await this.removeRoute();
      this.$validator.validateAll().then(result => {
        if (result) {
          //this.field.custom = false;
          this.submitted = true;
          this.settingsdata();
          setTimeout(() => {
            this.submitted = false;
          }, 3000);
        } else {
          this.error_show = true; // validate the form if fail
        }
      });
      return false;
    }
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    store
      .dispatch("settings/fetchCustomList", {
        stg_menu: "Payments Received"
      })
      .then(() => {
        next();
      });
    store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Payments Received",
        stg_name: "pymnt_settings_details"
      })
      .then(() => {
        next();
      });
  },
  beforeRouteEnter(to, from, next) {
    store
      .dispatch("settings/fetchCustomList", {
        stg_menu: "Payments Received"
      })
      .then(() => {
        next();
      });
    store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Payments Received",
        stg_name: "pymnt_settings_details"
      })
      .then(() => {
        next();
      });
  },
  created() {
    this.page = "";
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    page: {
      get() {
        return this.$store.state.settings.page;
      },
      set(val) {
        this.$store.state.settings.page = val;
      }
    },
    ...mapState({
      field: state =>
        state.settings.list["Payments Received"] || { custom_field: {} },
      list: state => state.settings.list,
      custom_field: state => state.settings.custom_list,
      message: state => state.settings.delete_message,
      code: state => state.settings.code,
      max_count: state => state.settings.max_count,
      used_count: state => state.settings.used_count,
      status_message: state => state.settings.status_message
    }),
    pymnt_settings_details: {
      get() {
        return this.$store.state.permission.pymnt_settings_details;
      },
      set(val) {
        this.$store.state.permission.pymnt_settings_details = val;
      }
    }
  }
};
</script>